module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead5-9ac88fef5dd30014d224c28bef7b3ba5.jpg";